import {
  useCallback, useState, useEffect, useRef,
} from 'react';
import { useSelector } from 'react-redux';
import noop from 'lodash/noop';
import WSS from '../../../../shared/lib/wssAPI';

export default function usePinpadCheckReady({ errorCallback = noop }) {
  const timer = useRef();
  const [ isReady, setIsReady ] = useState(false);
  const {
    paymentMethodsConfig: {
      pinpadInfo: {
        pinpadProcessor,
        pinpadIdentifier,
      } = {},
    } = {},
  } = useSelector(state => state.propsData);

  const wssProcess = ({
    request, resolve, reject,
  }) => {
    WSS.sendWSPromise(request)
      .then(resolve)
      .catch(reject);
  };

  const checkAPDReady = useCallback(({ resolveCallback, commitCallback } = {}) => {
    const readyRequest = WSS.getWSRequest(
      WSS.RequestMethod.EXEC,
      WSS.FunctionName.IS_APD_READY,
      '',
      pinpadProcessor,
      pinpadIdentifier);
    wssProcess({
      request: readyRequest,
      resolve: (({ value }) => { // value is true|false
        if (value) {
          setIsReady(true);
          timer.current && clearInterval(timer.current);
          resolveCallback?.(commitCallback);
        } else {
          setIsReady(false);
          commitCallback?.({ status: false, errorCode: 'PINPAD_CHECKREADY_FAILED' });
        }
      }),
      reject: (() => {
        setIsReady(false);
        commitCallback?.({ status: false, errorCode: 'PINPAD_CHECKREADY_FAILED' });
      }),
    });
  }, [ pinpadProcessor ]);

  useEffect(() => {
    timer.current = setInterval(() => {
      checkAPDReady({ commitCallback: errorCallback });
    }, 1000);
    return () => {
      timer.current && clearInterval(timer.current);
    };
  }, [ checkAPDReady, errorCallback ]);

  return {
    isReady, checkAPDReady, wssProcess,
  };
}
